import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';

/** Normalized option used by every <select> in the app. */
export interface DropdownItem {
  value: number | string;
  label: string;
}

/** Coerce whatever shape the API returns into { value, label }[]. */
export function normalizeDropdown(raw: any): DropdownItem[] {
  const data = raw?.data ?? raw ?? [];
  if (!Array.isArray(data)) return [];
  return data
    .map((x: any) => {
      if (x == null) return null;
      if (typeof x === 'string' || typeof x === 'number') {
        return { value: x, label: String(x) };
      }
      const value = x.value ?? x.id ?? x.key ?? x.code;
      const label = x.text ?? x.label ?? x.name ?? x.title ?? x.displayName ?? String(value);
      return value == null ? null : { value, label };
    })
    .filter((x): x is DropdownItem => x != null);
}

@Injectable({ providedIn: 'root' })
export class DropdownService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/Dropdown`;

  private list(path: string, params?: any) {
    return this.http
      .get(`${this.baseUrl}/${path}`, params ? { params } : {})
      .pipe(map(normalizeDropdown));
  }

  roles() {
    return this.list('Roles');
  }
  users() {
    return this.list('Users');
  }
  partners() {
    return this.list('Partners');
  }
  seriesMaster() {
    return this.list('SeriesMaster');
  }
  seriesType() {
    return this.list('SeriesType');
  }
  policies() {
    return this.list('Policies');
  }
  permissions() {
    return this.list('Permissions');
  }
  menus() {
    return this.list('Menus');
  }

  /** Generic lookups. */
  get(type: string, key?: string) {
    return this.list('Get', key ? { type, key } : { type });
  }
  globalType(key: string) {
    return this.list('GlobalType', { key });
  }
  enumValues(name: string) {
    return this.list('Enum', { name });
  }
}
